module.exports = __webpack_public_path__ + "static/media/menu-button.bebd6e76.svg";